import { Injectable } from "@angular/core";

import { of } from 'rxjs';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';

import { Actions, createEffect, ofType } from "@ngrx/effects";

import { fetchAhjsData, fetchAhjsFailure, fetchAhjsSuccess, fetchAllAhjsData, fetchAllAhjsFailure, fetchAllAhjsSuccess, fetchAllUtilitiesData, fetchAllUtilitiesFailure, fetchAllUtilitiesSuccess, fetchAmbientTempData, fetchAmbientTempDataFailure, fetchAmbientTempDataSuccess, fetchAttachmentTypeData, fetchAttachmentTypeFailure, fetchAttachmentTypeSuccess, fetchBatteryMakesData, fetchBatteryMakesFailure, fetchBatteryMakesSuccess, fetchBatteryModelsData, fetchBatteryModelsFailure, fetchBatteryModelsSuccess, fetchFramingData, fetchFramingDataFailure, fetchFramingDataSuccess, fetchGovernignCodesData, fetchGovernignCodesFailure, fetchGovernignCodesSuccess, fetchInverterMakesData, fetchInverterMakesFailure, fetchInverterMakesSuccess, fetchInverterModelsData, fetchInverterModelsFailure, fetchInverterModelsSuccess, fetchModuleMakesData, fetchModuleMakesFailure, fetchModuleMakesSuccess, fetchModuleModelsData, fetchModuleModelsFailure, fetchModuleModelsSuccess, fetchMSPBrandsData, fetchMSPBrandsDataFailure, fetchMSPBrandsDataSuccess, fetchOptimizerData, fetchOptimizerFailure, fetchOptimizerSuccess, fetchRackingMakeData, fetchRackingMakeFailure, fetchRackingMakeSuccess, fetchRackingModelsData, fetchRackingModelsFailure, fetchRackingModelsSuccess, fetchRoofMaterialData, fetchRoofMaterialFailure, fetchRoofMaterialSuccess, fetchSingleAttachmentTypeData, fetchSingleAttachmentTypeFailure, fetchSingleAttachmentTypeSuccess, fetchSingleRackingMakeData, fetchSingleRackingMakeFailure, fetchSingleRackingMakeSuccess, fetchSingleRackingModelsData, fetchSingleRackingModelsFailure, fetchSingleRackingModelsSuccess, fetchUtilitiesData, fetchUtilitiesFailure, fetchUtilitiesSuccess } from "./dataentry.actions";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { GlobalComponent } from "../../global-component";
import { ToastifyService } from "../../shared/toastify-service";
import { startAfter } from "@angular/fire/firestore";
import { TokenStorageService } from "../../core/services/token-storage.service";


@Injectable()
export class DataentryEffects {

  

  /**
   * FETCH MODULE MAKES LIST
   */
  fetchModuleMakesData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchModuleMakesData),
      mergeMap(() =>

        //backend api
        // this.dataEntryService.getModuleMakes().pipe(
        //     map((modulemakesarray) => {
        //       console.log('sdfsdfsdf')
        //       const modulemakes = modulemakesarray;
        //       return fetchModuleMakesSuccess({ modulemakes });
        //     }),
        //     catchError((error) =>
        //     of( fetchModuleMakesFailure(error))
        //     )
        //   )
        //firebase
        this.afs.collection(GlobalComponent.firebasemodulemakebasecollname, ref => ref.where('status', '==', true).orderBy('name', 'asc').where('vendorguid', 'array-contains', this.tokenService.getUser().vendorguid))
          .valueChanges().pipe(
            map((docs: any) => {
              return fetchModuleMakesSuccess({ modulemakes: docs });
            }),
            catchError((error) =>
              of(fetchModuleMakesFailure({ error }))
            )
          )
      ),
    ),
  );

  /**
     * FETCH MODULE MODELS LIST
     */
  fetchModuleModelsData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchModuleModelsData),
      mergeMap(({ modulemakeguid }) =>
        //api backend
        // this.dataEntryService.getModuleModels().pipe(
        //     map((modulemodelsarray) => {
        //       const modulemodels = modulemodelsarray;
        //       return fetchModuleModelsSuccess({ modulemodels });
        //     }),
        //     catchError((error) =>
        //       of( fetchModuleModelsFailure({ error }))
        //     )
        //   )

        //FIREBASE
        this.afs.collection(GlobalComponent.firebasemodulemodelbasecollname, ref => ref.where('modulemakeguid', '==', modulemakeguid).where('status', '==', true).orderBy('name', 'asc').where('vendorguid', 'array-contains', this.tokenService.getUser().vendorguid))
          .valueChanges().pipe(
            map((docs: any) => {
              return fetchModuleModelsSuccess({ modulemodels: docs });
            }),
            catchError((error) =>
              of(fetchModuleModelsFailure({ error }))
            )
          )
      ),
    ),
  );

  /**
   * FETCH INVERTER MAKES LIST
   */
  fetchInverterMakesData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchInverterMakesData),
      mergeMap(() =>
        //firebase
        this.afs.collection(GlobalComponent.firebaseinvertermakebasecollname, ref => ref.where('status', '==', true).orderBy('name', 'asc').where('vendorguid', 'array-contains', this.tokenService.getUser().vendorguid))
          .valueChanges().pipe(
            map((docs: any) => {
              return fetchInverterMakesSuccess({ invertermakes: docs });
            }),
            catchError((error) =>
              of(fetchInverterMakesFailure({ error }))
            )
          )
      ),
    ),
  );

  /**
     * FETCH MODULE MODELS LIST
     */
  fetchInverterModelsData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchInverterModelsData),
      mergeMap(({ invertermakeguid }) =>
        //FIREBASE
        this.afs.collection(GlobalComponent.firebaseinvertermodelbasecollname, ref => ref.where('invertermakeguid', '==', invertermakeguid).where('status', '==', true).orderBy('name', 'asc').where('vendorguid', 'array-contains', this.tokenService.getUser().vendorguid))
          .valueChanges().pipe(
            map((docs: any) => {
              return fetchInverterModelsSuccess({ invertermodels: docs });
            }),
            catchError((error) =>
              of(fetchInverterModelsFailure({ error }))
            )
          )
      ),
    ),
  );

  /**
   * FETCH AHJS LIST
   */
  fetchAhjsData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchAhjsData),
      tap(({ state }) => {
        console.log('State received in effect:', state);
      }),
      mergeMap(({state}) =>
        //firebase
        this.afs.collection('ahjslist', ref => ref.where('status', '==', true).where('state', '==', state))
          .valueChanges().pipe(
            map((docs: any) => {
              return fetchAhjsSuccess({ ahjs: docs });
            }),
            catchError((error) =>
              of(fetchAhjsFailure({ error }))
            )
          )
      ),
    ),
  );

   /**
   * FETCH UTILITIES LIST
   */
   fetchUtilitiesData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchUtilitiesData),
      mergeMap(({state}) =>
        //firebase
        this.afs.collection('utilities', ref => ref.where('status', '==', true).where('state', '==', state).orderBy('name', 'asc'))
          .valueChanges().pipe(
            map((docs: any) => {
              // console.log("docss", docs)
              return fetchUtilitiesSuccess({ utilities: docs });
            }),
            catchError((error) =>
              of(fetchUtilitiesFailure({ error }))
            )
          )
      ),
    ),
  );

  /**
   * FETCH BATTERY MAKES LIST
   */
  fetchBatteryMakesData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchBatteryMakesData),
      mergeMap(() =>
        //firebase
        this.afs.collection(GlobalComponent.firebasebatterymakebasecollname, ref => ref.where('status', '==', true).orderBy('name', 'asc').where('vendorguid', 'array-contains', this.tokenService.getUser().vendorguid))
          .valueChanges().pipe(
            map((docs: any) => {
              return fetchBatteryMakesSuccess({ batterymakes: docs });
            }),
            catchError((error) =>
              of(fetchBatteryMakesFailure({ error }))
            )
          )
      ),
    ),
  );

  fetchBatteryMakesFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fetchBatteryMakesFailure),
        tap((error: any) => {
          console.log('error', error);
          this.toastifyService.showErrorMessage(error.error ? error.error.message : 'something went wrong, please check again');
        })
      ),
    { dispatch: false }
  );

  /**
     * FETCH BATTERY MODELS LIST
     */
  fetchBatteryModelsData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchBatteryModelsData),
      mergeMap(({ batterymakeguid }) =>
        //FIREBASE
        this.afs.collection(GlobalComponent.firebasebatterymodelbasecollname, ref => ref.where('batterymakeguid', '==', batterymakeguid).where('status', '==', true).orderBy('name', 'asc').where('vendorguid', 'array-contains', this.tokenService.getUser().vendorguid))
          .valueChanges().pipe(
            map((docs: any) => {
              return fetchBatteryModelsSuccess({ batterymodels: docs });
            }),
            catchError((error) =>
              of(fetchBatteryModelsFailure({ error }))
            )
          )
      ),
    ),
  );

  fetchBatteryModelsFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fetchBatteryModelsFailure),
        tap((error: any) => {
          console.log('error', error);
          this.toastifyService.showErrorMessage(error.error ? error.error.message : 'something went wrong, please check again');
        })
      ),
    { dispatch: false }
  );

  /**
   * FETCH OPTIMIZERS LIST
   */
  fetchOptimizersData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchOptimizerData),
      mergeMap(() =>
        //firebase
        this.afs.collection(GlobalComponent.firebaseoptimizersbasecollname, ref => ref.where('status', '==', true).orderBy('name', 'asc').where('vendorguid', 'array-contains', this.tokenService.getUser().vendorguid))
          .valueChanges().pipe(
            map((docs: any) => {
              return fetchOptimizerSuccess({ optimizers: docs });
            }),
            catchError((error) =>
              of(fetchOptimizerFailure({ error }))
            )
          )
      ),
    ),
  );

  fetchOptimizerFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fetchOptimizerFailure),
        tap((error: any) => {
          console.log('error', error);
          this.toastifyService.showErrorMessage(error.error ? error.error.message : 'something went wrong, please check again');
        })
      ),
    { dispatch: false }
  );

  /**
   * FETCH GOVERNING CODES LIST
   */
  fetchGovernignCodesData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchGovernignCodesData),
      mergeMap(({ statename, ahjname }) =>
        //firebase
        this.afs.collection(GlobalComponent.firebasegoverningcodesbasecollname, ref => ref.where('status', '==', true).where('ahjname', '==', ahjname).where('state', '==', statename))
          .valueChanges().pipe(
            map((docs: any) => {
              return fetchGovernignCodesSuccess({ governingcodes: docs });
            }),
            catchError((error) =>
              of(fetchGovernignCodesFailure({ error }))
            )
          )
      ),
    ),
  );

  fetchGovernignCodesFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fetchGovernignCodesFailure),
        tap((error: any) => {
          console.log('error', error);
          this.toastifyService.showErrorMessage(error.error ? error.error.message : 'something went wrong, please check again');
        })
      ),
    { dispatch: false }
  );

  /**
   * FETCH RACKING MAKES LIST
   */
  fetchRackingMakeData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchRackingMakeData),
      mergeMap(() =>
        //firebase
        this.afs.collection(GlobalComponent.firebaserackingmakecollname, ref => ref.where('status', '==', true).orderBy('name', 'asc').where('vendorguid', 'array-contains', this.tokenService.getUser().vendorguid))
          .valueChanges().pipe(
            map((docs: any) => {
              return fetchRackingMakeSuccess({ rackingmakes: docs });
            }),
            catchError((error) =>
              of(fetchRackingMakeFailure({ error }))
            )
          )
      ),
    ),
  );

  /**
   * FETCH RACKING MAKES LIST
   */
  fetchRackingModelsData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchRackingModelsData),
      mergeMap(({ rackingmakeguid }) =>
        //firebase
        this.afs.collection(GlobalComponent.firebaserackingmodelcollname, ref => ref.where('rackingnameguid', '==', rackingmakeguid).where('status', '==', true).orderBy('name', 'asc'))
          .valueChanges().pipe(
            map((docs: any) => {
              return fetchRackingModelsSuccess({ rackingmodels: docs });
            }),
            catchError((error) =>
              of(fetchRackingModelsFailure({ error }))
            )
          )
      ),
    ),
  );

  /**
   * FETCH ATTACHMENT TYPE LIST
   */
  fetchAttachmentTypeData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchAttachmentTypeData),
      mergeMap(() =>
        //firebase
        this.afs.collection(GlobalComponent.firebaseattachmenttypecollname, ref => ref.where('status', '==', true).orderBy('name', 'asc').where('vendorguid', 'array-contains', this.tokenService.getUser().vendorguid))
          .valueChanges().pipe(
            map((docs: any) => {
              return fetchAttachmentTypeSuccess({ attachmenttypes: docs });
            }),
            catchError((error) =>
              of(fetchAttachmentTypeFailure({ error }))
            )
          )
      ),
    ),
  );

  /**
   * FETCH SINGLE RACKING MAKES LIST
   */
  fetchSingleRackingMakeData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchSingleRackingMakeData),
      mergeMap(({ guid }) =>
        //firebase
        this.afs.collection(GlobalComponent.firebaserackingmakecollname, ref => ref.where('guid', '==', guid))
          .valueChanges().pipe(
            map((docs: any) => {
              return fetchSingleRackingMakeSuccess({ rackingmake: docs });
            }),
            catchError((error) =>
              of(fetchSingleRackingMakeFailure({ error }))
            )
          )
      ),
    ),
  );

  /**
   * FETCH SINGLE RACKING MAKES LIST
   */
  fetchSingleRackingModelsData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchSingleRackingModelsData),
      mergeMap(({ guid }) =>
        //firebase
        this.afs.collection(GlobalComponent.firebaserackingmodelcollname, ref => ref.where('guid', '==', guid))
          .valueChanges().pipe(
            map((docs: any) => {
              return fetchSingleRackingModelsSuccess({ rackingmodel: docs });
            }),
            catchError((error) =>
              of(fetchSingleRackingModelsFailure({ error }))
            )
          )
      ),
    ),
  );

  /**
   * FETCH SINGLE ATTACHMENT TYPE LIST
   */
  fetchSingleAttachmentTypeData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchSingleAttachmentTypeData),
      mergeMap(({ guid }) =>
        //firebase
        this.afs.collection(GlobalComponent.firebaseattachmenttypecollname, ref => ref.where('guid', '==', guid))
          .valueChanges().pipe(
            map((docs: any) => {
              return fetchSingleAttachmentTypeSuccess({ attachmenttype: docs });
            }),
            catchError((error) =>
              of(fetchSingleAttachmentTypeFailure({ error }))
            )
          )
      ),
    ),
  );

   /**
   * FETCH ROOF MATERIAL LIST
   */
   fetchRoofMaterialsData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchRoofMaterialData),
      mergeMap(() =>
        //firebase
        this.afs.collection(GlobalComponent.firebaseroofmaterialscollname, ref => ref.where('status', '==', true).orderBy('name', 'asc').where('vendorguid', 'array-contains', this.tokenService.getUser().vendorguid))
          .valueChanges().pipe(
            map((docs: any) => {
              return fetchRoofMaterialSuccess({ roofmaterials: docs });
            }),
            catchError((error) =>
              of(fetchRoofMaterialFailure({ error }))
            )
          )
      ),
    ),
  );

  /**
   * FETCH ROOF MATERIAL LIST
   */
  fetchFramingData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchFramingData),
      mergeMap(() =>
        //firebase
        this.afs.collection('framingdata').doc('8lUvjIR7gYICVE7jboip')
          .valueChanges().pipe(
            map((docs: any) => {
              return fetchFramingDataSuccess({ framingdata: docs });
            }),
            catchError((error) =>
              of(fetchFramingDataFailure({ error }))
            )
          )
      ),
    ),
  );

   /**
   * FETCH AMBIENT TEMP LIST
   */
   fetchAmbientTempData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchAmbientTempData),
      mergeMap(({ state, city, snowloadkey }) =>
        //firebase
        this.afs.collection(GlobalComponent.firebaseambienttempcollname, ref => ref.where('status', '==', true).where('state', '==', state).where('city', '==', city).where('snowloadkey', '==', snowloadkey).orderBy('createdAt', 'desc'))
          .valueChanges().pipe(
            map((docs: any) => {
              return fetchAmbientTempDataSuccess({ ambienttemps: docs });
            }),
            catchError((error) =>
              of(fetchAmbientTempDataFailure({ error }))
            )
          )
      ),
    ),
  );


      /**
   * FETCH All AHJS LIST
   */
  fetchAllAhjsData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchAllAhjsData),
      mergeMap(({ limit, startAfter, searchoptions }) => {
        
        //firebase
        return this.afs.collection('ahjs', ref => {
          let query = ref.where('status', '==', true)
          if (searchoptions && searchoptions.key && searchoptions.value) {
            const searchby = searchoptions.key;
            const searchvalue = searchoptions.value;
            switch (searchby) {
              case "name": {
                query = query.where(searchby, '>=', searchvalue).where(searchby, '<=', searchvalue + '\uf8ff');
                break
              }
              case "guid": {
                query = query.where(searchby, 'in', searchvalue);
                break
              }
              default : {
                break
              }  
            }
          }
          query = query.orderBy("name", "asc")
          if (startAfter) {
            query = query.startAfter(startAfter)
          }
          if (limit) {
            query = query.limit(limit)
          } else {
            query = query.limit(20)
          }
          return query
        }
        )
        .valueChanges().pipe(
          map((docs: any) => {
            return fetchAllAhjsSuccess({ ahjs: docs });
          }),
          catchError((error) =>
            of(fetchAllAhjsFailure({ error }))
          )
        )
      }
        
        
      ),
    ),
);

 /**
 * FETCH UTILITIES LIST
 */
 fetchAllUtilitiesData$ = createEffect(() =>
  this.actions$.pipe(
    ofType(fetchAllUtilitiesData),
    mergeMap(({ startAfter, limit, searchoptions }) => {
      //firebase
      return this.afs.collection('utilities', ref => {
        let query = ref.where('status', '==', true)
        if (searchoptions && searchoptions.key && searchoptions.value) {
          const searchby = searchoptions.key;
            const searchvalue = searchoptions.value;
            switch (searchby) {
              case "name": {
                query = query.where(searchby, '>=', searchvalue).where(searchby, '<=', searchvalue + '\uf8ff');
                break
              }
              case "guid": {
                query = query.where(searchby, 'in', searchvalue);
                break
              }
              default : {
                break
              }  
            }
        }
          query = query.orderBy("name", "asc")
          if (startAfter) {
            query = query.startAfter(startAfter)
          }
          if (limit) {
            query = query.limit(limit)
          } else {
            query = query.limit(20)
          }
          return query
        }
      )
        .valueChanges().pipe(
          map((docs: any) => {
            // console.log("docss", docs)
            return fetchAllUtilitiesSuccess({ utilities: docs });
          }),
          catchError((error) =>
            of(fetchAllUtilitiesFailure({ error }))
          )
        )
    }
    ),
  ),
);

/**
   * FETCH MSP BRANDS DATA
   */
fetchMSPBrandsData$ = createEffect(() =>
  this.actions$.pipe(
    ofType(fetchMSPBrandsData),
    mergeMap(() =>
      //firebase
      this.afs.collection(GlobalComponent.firebasemspbrandscollname, ref => ref.where('status', '==', true).where('vendorguid', 'array-contains', this.tokenService.getUser().vendorguid))
        .valueChanges().pipe(
          map((docs: any) => {
            return fetchMSPBrandsDataSuccess({ mspbrands: docs });
          }),
          catchError((error) =>
            of(fetchMSPBrandsDataFailure({ error }))
          )
        )
    ),
  ),
);


  constructor(
    private actions$: Actions,
    private afs: AngularFirestore,
    private toastifyService: ToastifyService,
    private tokenService: TokenStorageService
  ) {
  }
}